module.exports = __webpack_public_path__ + "img/product_74.d0c8988.webp";